import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { CourseParent } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Migrate course to new architecture
 * @param course_id
 */
const migrateCourse = (course_id: string | string[]): Promise<CourseParent> => {
  const tokenId = Cookies.get(AUTH_TOKEN_KEY)
  const URL = routes.COURSE + course_id + '/migrate'
  const config = {
    headers: {
      Authorization: `Bearer ${tokenId}`,
    },
  }
  return new Promise((resolve, reject) => {
    AxiosClient.post(URL, {}, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default migrateCourse
